// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__alonG","toggle":"styles_toggle__394Vk","preview":"styles_preview__3kNNy"};